import React, { useState, useEffect, useContext, useRef } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Container from '@material-ui/core/Container'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import Markdown from '../ui/Markdown'

import Section from './Section'

const styles = theme => ({
  root: {
    display: 'flex',
    overflow: 'hidden',
  },
  imageCenter: {
    width: '100%',
//    [theme.breakpoints.down('sm')]: {    
//      marginLeft: theme.spacing(-2),
//      width: 'calc(100% + 32px)'
//    }
  },  
  imageSide: {
    width: '100%',
  },
  imageDiv: {
    width: '44%'
  },
  spacingDiv: {
    width: '6%',
  },
  contentDiv: {
    width: '50%',
  }
  
});

const ExpansionList = (props) => {
  const { theme, classes, variant, color_mode, items, removeNotFullRow=false, renderItem=null, openLink } = props
  
  
  const [expanded, setExpanded] = useState(false)

  const handleChange = panel => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }
    
  return (
    <Section { ...props } variant='Center'>
      <Box width='100%'>

      <Grid container>
      { items !== undefined && items.map((item, index) => (
        <Grid item xs={12} sm={6}>
          <ExpansionPanel 
            expanded={expanded === 'panel-' + index} 
            onChange={handleChange('panel-' + index)}
            style={{ width: '100%' }}
            >
            
          <ExpansionPanelSummary
              expandIcon={<ExpandMoreIcon />}
            >
              <Markdown source={ item.name } dark={color_mode == 'dark'}/>
            </ExpansionPanelSummary>
    
          <ExpansionPanelDetails>
              <Box display='flex' flexDirection='column'>
                <Markdown source={ item.body } dark={color_mode == 'dark'}/>

                { item.link_to && item.link_to !== undefined &&
                  <Box align="left" mt={3}>
                    <Button variant='outlined' color="primary" style={{ textTransform: 'none', fontSize: theme.typography.body1.fontSize }} onClick={ () => openLink(item.link_to) }>
                      { item.link_title }
                    </Button>
                  </Box>
                }
                
              </Box>
            </ExpansionPanelDetails>
        </ExpansionPanel>
      </Grid>
    ))}
    </Grid>
      
      </Box>
    </Section>
  )
}

ExpansionList.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(ExpansionList);